import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import SidebarContent from "./SidebarContent"
import { useSelector } from "react-redux"
import { random } from "lodash"

const Sidebar = ({ props }) => {
    const [sidebarKey, setSidebarKey] = useState();
    const Account = useSelector(state => state?.Account)
    const takeBacks = useSelector(state => state?.TakeBacks);
    const takebackId = takeBacks?.items?.[0]?.id;

    useEffect(() => {
      //SidebarContent.tsx uses random key for rerendering when sidebar content changes
      // without it there are bugs occuring with menu accordions and redirects
        setSidebarKey(random(0, 1000))
    }, [Account?.info?.configuration?.details, takebackId])

    return (
        <div className="vertical-menu">
            <div data-simplebar className="h-100">
                {!Account?.info?.isLoading ? (
                  <SidebarContent
                    key={sidebarKey}
                  />
                ): null}
            </div>
        </div>
    )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

export default withRouter(Sidebar)
